"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var NoClones_exports = {};
__export(NoClones_exports, {
  default: () => NoClones_default
});
module.exports = __toCommonJS(NoClones_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.5 2.8999C4.06406 2.8999 2.9 4.06396 2.9 5.4999V13.4999C2.9 14.9358 4.06406 16.0999 5.5 16.0999H13.5C14.9359 16.0999 16.1 14.9358 16.1 13.4999V5.4999C16.1 4.06396 14.9359 2.8999 13.5 2.8999H5.5ZM4.1 5.4999C4.1 4.7267 4.7268 4.0999 5.5 4.0999H13.5C14.2732 4.0999 14.9 4.7267 14.9 5.4999V7.8999H13.7C13.3686 7.8999 13.1 8.16853 13.1 8.4999C13.1 8.83127 13.3686 9.0999 13.7 9.0999H14.9V13.4999C14.9 14.2731 14.2732 14.8999 13.5 14.8999H9.1V13.6999C9.1 13.3685 8.83137 13.0999 8.5 13.0999C8.16863 13.0999 7.9 13.3685 7.9 13.6999V14.8999H5.5C4.7268 14.8999 4.1 14.2731 4.1 13.4999V5.4999ZM10.0671 9.16796C10.2026 9.12393 10.3479 9.0999 10.5 9.0999H11.3C11.6314 9.0999 11.9 8.83127 11.9 8.4999C11.9 8.16853 11.6314 7.8999 11.3 7.8999H10.5C10.2205 7.8999 9.95025 7.94421 9.69644 8.02663C9.38127 8.12897 9.20874 8.46743 9.31108 8.7826C9.41343 9.09777 9.75189 9.2703 10.0671 9.16796ZM17.7 7.8999C17.3686 7.8999 17.1 8.16853 17.1 8.4999C17.1 8.83127 17.3686 9.0999 17.7 9.0999H18.5C18.6521 9.0999 18.7974 9.12393 18.9329 9.16796C19.2481 9.2703 19.5866 9.09777 19.6889 8.7826C19.7913 8.46743 19.6187 8.12897 19.3036 8.02663C19.0498 7.94421 18.7795 7.8999 18.5 7.8999H17.7ZM9.16806 10.067C9.2704 9.75179 9.09787 9.41333 8.7827 9.31099C8.46753 9.20864 8.12907 9.38117 8.02672 9.69634C7.94431 9.95015 7.9 10.2204 7.9 10.4999V11.2999C7.9 11.6313 8.16863 11.8999 8.5 11.8999C8.83137 11.8999 9.1 11.6313 9.1 11.2999V10.4999C9.1 10.3478 9.12403 10.2025 9.16806 10.067ZM20.9733 9.69634C20.8709 9.38117 20.5325 9.20864 20.2173 9.31099C19.9021 9.41333 19.7296 9.75179 19.8319 10.067C19.876 10.2025 19.9 10.3478 19.9 10.4999V11.2999C19.9 11.6313 20.1686 11.8999 20.5 11.8999C20.8314 11.8999 21.1 11.6313 21.1 11.2999V10.4999C21.1 10.2204 21.0557 9.95015 20.9733 9.69634ZM21.1 13.6999C21.1 13.3685 20.8314 13.0999 20.5 13.0999C20.1686 13.0999 19.9 13.3685 19.9 13.6999V15.2999C19.9 15.6313 20.1686 15.8999 20.5 15.8999C20.8314 15.8999 21.1 15.6313 21.1 15.2999V13.6999ZM9.1 17.6999C9.1 17.3685 8.83137 17.0999 8.5 17.0999C8.16863 17.0999 7.9 17.3685 7.9 17.6999V18.4999C7.9 18.7794 7.94431 19.0497 8.02672 19.3035C8.12907 19.6186 8.46753 19.7912 8.7827 19.6888C9.09787 19.5865 9.2704 19.248 9.16806 18.9328C9.12403 18.7973 9.1 18.652 9.1 18.4999V17.6999ZM21.1 17.6999C21.1 17.3685 20.8314 17.0999 20.5 17.0999C20.1686 17.0999 19.9 17.3685 19.9 17.6999V18.4999C19.9 18.652 19.876 18.7973 19.8319 18.9328C19.7296 19.248 19.9021 19.5865 20.2173 19.6888C20.5325 19.7912 20.8709 19.6186 20.9733 19.3035C21.0557 19.0497 21.1 18.7794 21.1 18.4999V17.6999ZM10.0671 19.8318C9.75189 19.7295 9.41343 19.902 9.31108 20.2172C9.20874 20.5324 9.38127 20.8708 9.69644 20.9732C9.95025 21.0556 10.2205 21.0999 10.5 21.0999H11.3C11.6314 21.0999 11.9 20.8313 11.9 20.4999C11.9 20.1685 11.6314 19.8999 11.3 19.8999H10.5C10.3479 19.8999 10.2026 19.8759 10.0671 19.8318ZM19.3036 20.9732C19.6187 20.8708 19.7913 20.5324 19.6889 20.2172C19.5866 19.902 19.2481 19.7295 18.9329 19.8318C18.7974 19.8759 18.6521 19.8999 18.5 19.8999H17.7C17.3686 19.8999 17.1 20.1685 17.1 20.4999C17.1 20.8313 17.3686 21.0999 17.7 21.0999H18.5C18.7795 21.0999 19.0498 21.0556 19.3036 20.9732ZM13.7 19.8999C13.3686 19.8999 13.1 20.1685 13.1 20.4999C13.1 20.8313 13.3686 21.0999 13.7 21.0999H15.3C15.6314 21.0999 15.9 20.8313 15.9 20.4999C15.9 20.1685 15.6314 19.8999 15.3 19.8999H13.7Z",
      fill: "currentColor"
    }
  )
);
const SvgNoClones = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var NoClones_default = SvgNoClones;
